





















































































import Vue from "vue";
/* eslint-disable */
import {
  createComponent,
  ref,
  computed,
  Ref,
  provide
} from "@vue/composition-api";
/* eslint-enable */
import {
  BaseTabControl,
  BaseTabControlHeaders,
  BaseTabControlHeadersItem,
  BaseTabControlContent,
  BaseTabControlContentItem
} from "@web-components";
import ActionPlanActivityCard from "@dcc/components/ActionPlanActivityCard.vue";
import ActionPlanFooterCart from "@dcc/components/ActionPlanFooterCart.vue";
import ActionPlanRegisterForm from "@dcc/components/ActionPlanRegisterForm.vue";
import SupportInfo from "@dcc/components/SupportInfo.vue";
import PlyrWrapper from "@dcc/components/PlyrWrapper.vue";

/* eslint-disable */
import {
  ActivityCategory,
  getActivityCategoryMap
} from "@dcc/types/activityCategory";
import { RiskLevel } from "@dcc/types/riskLevel";
/* eslint-enable */
import { findGetters } from "../store/activity/getters";
import { findGetters as findScoreGetters } from "../store/score/getters";
import { getActions as getActivityActions } from "../store/activity/actions";
import { getActions as getScoreActions } from "../store/score/actions";
//eslint-disable-next-line
import { UserDetails } from "@dcc/store/score/types";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

interface ActionPlanProps {
  tab: ActivityCategory;
}

export default createComponent({
  props: {
    tab: {
      type: String as () => ActivityCategory,
      required: true
    }
  },
  components: {
    BaseTabControl,
    BaseTabControlHeaders,
    BaseTabControlHeadersItem,
    BaseTabControlContent,
    BaseTabControlContentItem,
    ActionPlanFooterCart,
    ActionPlanActivityCard,
    ActionPlanRegisterForm,
    SupportInfo,
    PlyrWrapper
  },
  setup(props: ActionPlanProps, context) {
    const registerForm: Ref<HTMLElement | null> = ref(null);

    const dictionary = useDictionary();
    const activityCategoryMap = getActivityCategoryMap();
    const currentTab = ref(activityCategoryMap.indexOf(props.tab));

    //TODO: need to remove this default
    //https://screenmedia.visualstudio.com/Drinkaware/_workitems/edit/23113
    const videoUrl: Ref<string | null> = ref(null);
    const showVideo = ref(false);
    const showRegistration = ref(false);

    const { getByCategory, getSelectedIds } = findGetters(context.root.$store);
    const selectedActivities = getSelectedIds();

    const { getRiskLevelBeforeChanges } = findScoreGetters(context.root.$store);
    const showSupportInfo =
      getRiskLevelBeforeChanges().value === RiskLevel.High;

    const activities = computed(
      () =>
        getByCategory(activityCategoryMap[currentTab.value] as ActivityCategory)
          .value
    );
    const { toggleActivity } = getActivityActions(context.root.$store);
    const { saveActionPlan, trackSelectedActivities } = getScoreActions(
      context.root.$store
    );

    const handleSavePlan = () => {
      showRegistration.value = true;
      Vue.nextTick(function() {
        registerForm &&
          registerForm.value &&
          registerForm.value.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
      });

      trackSelectedActivities();
    };

    const handleActivitySelected = (id: number) => {
      if (
        selectedActivities.value.includes(id) &&
        selectedActivities.value.length === 1
      ) {
        showRegistration.value = false;
      }
      toggleActivity(id);
    };

    const handleImageClicked = (id: string) => {
      const activity = activities.value.find(a => a.id === id);
      if (activity && activity.videolink) {
        videoUrl.value = activity.videolink;
        showVideo.value = true;
      }
    };

    const handleVideoClose = () => {
      if (showVideo.value) {
        showVideo.value = false;
      }
    };

    const handleRegister = (userDetails: UserDetails) => {
      saveActionPlan(userDetails);
      context.root.$router.push({ name: "actionplanresults" });
    };

    const handleShowPlan = () => {
      context.root.$router.push({ name: "actionplanresults" });
    };

    provide("registerFormRef", registerForm);

    return {
      ActivityCategory,
      currentTab,
      activities,
      activityCategoryMap,
      selectedActivities,
      handleSavePlan,
      handleActivitySelected,
      handleImageClicked,
      handleVideoClose,
      handleShowPlan,
      handleRegister,
      videoUrl,
      showVideo,
      showRegistration,
      showSupportInfo,
      ...dictionary
    };
  }
});
